module.exports = __webpack_public_path__ + "img/fast-forward.73309d65.svg";